module.exports = __webpack_public_path__ + "static/media/lawyer.4330aa11.jpg";